import { Tooltip } from '@mui/material'

type TooltipTextProps = {
  text: string
  length?: number
  disableInteractive?: boolean
  placement?: 'bottom' | 'top' | 'left' | 'right'
  slotProps?: any
}

export const TooltipText = ({
  text,
  length = 25,
  disableInteractive,
  placement,
  slotProps,
}: TooltipTextProps) => {
  const truncatedValue = () => {
    return `${text.slice(0, length)}${text.length >= length ? '...' : ''}`
  }

  return text?.length > length ? (
    <Tooltip
      disableInteractive={!!disableInteractive}
      placement={placement || 'bottom'}
      slotProps={slotProps ?? {}}
      componentsProps={{
        tooltip: {
          sx: {
            padding: '0.25rem 0.75rem',
            fontSize: '0.75rem',
            fontWeight: '500',
            lineHeight: '1.5rem',
            width: 'max-content',
          },
        },
      }}
      title={
        <span
          onClick={(e) => (e?.stopPropagation ? e.stopPropagation() : '')} // Stop propagation
          onMouseDown={(e) => (e?.stopPropagation ? e.stopPropagation() : '')} // Prevent default
          onMouseUp={(e) => (e?.stopPropagation ? e.stopPropagation() : '')} // Prevent default
        >
          {text}
        </span>
      }
      arrow
    >
      <span data-testid='truncated'>{truncatedValue()}</span>
    </Tooltip>
  ) : (
    <span>{text || ''}</span>
  )
}
